import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  name: string;
  email: string;
}

interface AppState {
  // User
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  
  // Bookings
  bookings: any[];
  selectedBooking: any | null;
  setBookings: (bookings: any[]) => void;
  setSelectedBooking: (booking: any | null) => void;
  
  // UI
  isLoading: boolean;
  error: string | null;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  
  // Reset
  reset: () => void;
}

const initialState = {
  user: null,
  isAuthenticated: false,
  bookings: [],
  selectedBooking: null,
  isLoading: false,
  error: null,
};

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      ...initialState,
      
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      
      setBookings: (bookings) => set({ bookings }),
      setSelectedBooking: (booking) => set({ selectedBooking: booking }),
      
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
      
      reset: () => set(initialState),
    }),
    {
      name: 'odoo-mobile-app',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);